import { evaluationsHandlers } from 'evaluations/mocks/handlers/evaluation.handler';
import { lmsModuleHandlers } from 'lms/mocks/handlers';

export const mockHandlers = [...evaluationsHandlers, ...lmsModuleHandlers];
